import type { ComponentPropsWithoutRef } from "react";
import clsx from "clsx";
import GlassPanel from "./GlassPanel";
import styles from "./StatePanel.module.scss";

/* UI-DESIGN: loading, empty and error copy share a quiet, stable surface.
   Callers supply truthful content and ARIA state; this component owns geometry. */
export default function StatePanel({ className, ...props }: ComponentPropsWithoutRef<"div">) {
  return <GlassPanel {...props} className={clsx(styles.panel, className)} />;
}
